import { useState, useEffect, useCallback, useRef } from 'react';

interface TTSOptions {
  lang?: string;
  rate?: number;
  pitch?: number;
  volume?: number;
}

export const useTTS = () => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isSupported, setIsSupported] = useState(false);
  const synth = useRef<SpeechSynthesis | null>(null);
  const utterance = useRef<SpeechSynthesisUtterance | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'speechSynthesis' in window) {
      synth.current = window.speechSynthesis;
      setIsSupported(true);
    }
  }, []);

  const speak = useCallback((text: string, options: TTSOptions = {}) => {
    if (!synth.current) return;

    synth.current.cancel();

    const u = new SpeechSynthesisUtterance(text);
    u.lang = options.lang || 'hi-IN';
    u.rate = options.rate || 0.9;
    u.pitch = options.pitch || 1;
    u.volume = options.volume || 1;

    u.onstart = () => setIsSpeaking(true);
    u.onend = () => setIsSpeaking(false);
    u.onerror = (e) => {
      console.error('TTS Error:', e);
      setIsSpeaking(false);
    };

    utterance.current = u;
    synth.current.speak(u);
  }, []);

  const cancel = useCallback(() => {
    if (synth.current) {
      synth.current.cancel();
      setIsSpeaking(false);
    }
  }, []);

  return { speak, cancel, isSpeaking, isSupported };
};
